import { render, staticRenderFns } from "./TaskCommentMentionedNotification.vue?vue&type=template&id=9aa09226"
import script from "./TaskCommentMentionedNotification.vue?vue&type=script&lang=js"
export * from "./TaskCommentMentionedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports